import { GaugeIcon } from './GaugeIcon';

/**
 * author: Google
 * id EC7B7499-25F1-43D4-9A09-9742F5B6D3F2
 * name gauge
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gauge.svg
 * tags
 * - Home Automation 
 * - Automotive 
 */
export const BarometerIcon = GaugeIcon;
export default BarometerIcon